export function radToDeg (rad) {
  return rad * 180 / Math.PI
}